module.exports = __webpack_public_path__ + "9c2df2807d138feaf46115461f0e916f.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2113_teaser_image.jpg
// module id = 606
// module chunks = 0